
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { UbicacionProps } from '../../interfaces/turnos/UbicacionInterface';

export const defaultUbicacion: UbicacionProps = { id: 0, nombre: '', numero: 0, };

export interface stateProps {
    ubicacion:  UbicacionProps;
}

const initialState : stateProps = {
    ubicacion: defaultUbicacion,
};

export const ubicacionSlice = createSlice({
    name: 'ubicacion',
    initialState: initialState,
    reducers: {
        asignarUbicacion: ( state, { payload } : PayloadAction<stateProps> ) => {
            state.ubicacion = payload.ubicacion;
        },
    },
})

export const { asignarUbicacion } = ubicacionSlice.actions

export default ubicacionSlice.reducer